<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12" class="text-center">
				<div class="esgcontainer">
					<h1>Sustainability Score - UN Global Compact</h1>
				</div>
			</v-col>
			<p style="margin: 30px 50px;">This ESG survey measures your company’s sustainability in areas such as Human Rights, Labor, Environment, and Anti-Corruption, 
				in line with the UN Global Compact. You can also view the ESG scores of your suppliers. It’s aligned with key EU regulations like VSME, CSRD, and CSDDD. 
				Additionally, companies can now map their supply chain in the value chain form to identify risks, improve transparency, and strengthen sustainability across 
				their entire value chain.
			</p>
			<v-col cols="12" class="text-center">
				<div style="color: #1e7c83;">
					<h2>THE COMPANY VISION:</h2>
				</div>
			</v-col>
			<v-col cols="12" class="text-center">
				<v-textarea
					v-if="isEditing || !companyVision"
					v-model="companyVision"
					outlined
					rows="3"
					auto-grow
					placeholder="Write your company vision here..."
				></v-textarea>
				
				<div v-else class="vision-text pa-4">
					{{ companyVision }}
				</div>
				
				<v-btn
					v-if="companyVision && !isEditing"
					color="primary"
					class="white--text"
					@click="enableEditing"
					>
					Edit Vision
				</v-btn>
	
				<v-btn
					v-if="isEditing || !companyVision"
					color="primary"
					class="white--text"
					@click="saveCompanyVision"
				>
					Save Vision
				</v-btn>
			</v-col>
			<v-col cols="12">
				<nav class="navi main-nav">
					<ul>
						<li>
							<router-link :to="{ path: '/csr/esgscore/vsme' }">VSME</router-link>
						</li>
						<li>
							<a @click="goToValueChain()" :class="{ 'router-link-active': $route.path.includes('/csr/esgscore/valuechain') }">YOUR VALUE CHAIN</a>
						</li>
						<li>
							<router-link :to="{ name: 'esgpage' }">YOUR SCORE</router-link>
						</li>
						<li>
							<router-link :to="{ name: 'Connections Sustainability Overview', query: { year: selectedYear } }">CONNECTIONS
								SCORE</router-link>
						</li>
					</ul>
				</nav>
			</v-col>
			<router-view />
		</v-row>
	</v-container>
</template>

<script>

import CsrAPI from "../api/csr/csr"
import LoadingState from "../consts/LoadingState"
export default {
	data() {
		return {
			EsgYear: [],
			companyVision: "",
			isEditing: false,
		}
	},
	mounted() {  
		this.loadCompanyVision()
	},
	methods: {
		async goToValueChain() {
			try {
				const data = await CsrAPI.getExistingValueChain()

				if (data && data.length > 0) {
					const id = data[0].ID
					this.$router.push(`/csr/esgscore/valuechain/${id}`)
				} else {
					this.$router.push(`/csr/esgscore/valuechain`)
				}
			} catch (e) {
				console.error("Error checking value chain:", e)
				this.$router.push(`/csr/esgscore/valuechain`)
			}
		},
		saveCompanyVision() {
			CsrAPI.postCompanyVision(this.companyVision)
				.then( () => {
					this.isEditing = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully save company vision`,
						{ root: true }
					)
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadCompanyVision() {
			CsrAPI.getCompanyVision()
				.then((result) => {
					if (!this.isEditing) {
						const vision = result[0][0]?.companyVision || ""
						this.companyVision = vision
						this.isEditing = !vision
					}
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		enableEditing() {
			this.isEditing = true
		},
	}
}
</script>

<style scoped>
.vision-text {
	text-align: left;
	border: 1px solid #ccc;
	border-radius: 4px;
	min-height: 80px;
	background-color: #f9f9f9;
	white-space: pre-wrap;
	margin-bottom: 10px;
}

.esgcontainer {
	display: flex;
	width: 100%;
}

.navi ul {
	margin: 0;
}

.navi li {
	display: inline;
}

.navi a {
	display: inline-block;
	padding: 0.5em;
	font: inherit;
	margin: 10px;
	text-decoration: none;
	font-weight: bolder;
	color: gray;
}

.navi a:hover {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}

.main-nav {
	width: auto;
	text-align: center;
	font-size: 1.2em;
	margin-top: 0;
	padding: 15px 0;
}

.main-nav li {
	padding: 0;
}

a.router-link-active {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}
</style>